// components
import Main from './components/main/Main';
import Mobile from './components/mobile/Mobile';

function App() {

	let isMobileDevice = window.navigator.userAgent.toLowerCase().includes("mobi");

	isMobileDevice = false;

	console.log(isMobileDevice)

	return (
		isMobileDevice ?
		<Mobile /> : <Main />
	);
}

export default App;
